import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useDevicesStore = defineStore('devices', {
  state: () => ({
    devices: useStorage('devices', []),
    deviceTelemetry: useStorage('deviceTelemetry', {}),
  }),
  actions: {
    setDevices(devices) {
      this.devices = devices
    },
    getDevices() {
      return this.devices
    },
    clearDevices() {
      this.devices = {}
    },

    setDeviceTelemetry(deviceId, telemetry) {
      if (!this.deviceTelemetry[deviceId]) {
        this.deviceTelemetry[deviceId] = {}
      }
      const unpackedTelemetry = this.unpackJson(telemetry)
      // Actualiza cada llave del objeto telemetry
      Object.keys(unpackedTelemetry).forEach(key => {
        this.deviceTelemetry[deviceId][key] = unpackedTelemetry[key]
      })
      // Guarda el timestamp de la última actualización
      this.deviceTelemetry[deviceId].timestamp = new Date()
    },
    getDeviceTelemetry(deviceId) {
      return this.deviceTelemetry[deviceId] || {}
    },
    clearDeviceTelemetry(deviceId) {
      this.deviceTelemetry[deviceId] = {}
    },
    getAllDevicesIds() {
      const ids = []
      this.devices.forEach(device => {
        ids.push(device.device_sn);
        if (device.children) {
          ids.push(device.children.device_sn);
        }
      })
      return ids
    },
    getDeviceConnected(deviceId) {
      const lastTimestamp = this.deviceTelemetry[deviceId]?.timestamp;
      if (!lastTimestamp) return false;
      const currentTime = new Date();
      const timeDiff = currentTime - new Date(lastTimestamp);
      const threshold = 5 * 60 * 1000; // 5 minutos en milisegundos
      return timeDiff <= threshold;
    },
    unpackJson(obj, prefix = '') {
      const result = {};
      function recurse(current, path) {
        if (Array.isArray(current)) {
          current.forEach((item, idx) => {
            recurse(item, `${path}${path ? '.' : ''}${idx}`);
          });
        } else if (typeof current === 'object' && current !== null) {
          Object.keys(current).forEach(key => {
            recurse(current[key], `${path}${path ? '.' : ''}${key}`);
          });
        } else {
          result[path] = current;
        }
      }
      recurse(obj, prefix);
      return result;
    },
    getDeviceModeCode(deviceId) {
      const d = this.deviceTelemetry[deviceId]
      console.log(d)
      if (d === undefined) {
        return -1
      } else {
        const mode_code = d["mode_code"]
        return mode_code
      }
    }
  },
})